<template>
  <div class="app-download">
    <img src="../assets/images/open_imgs.png" v-if="weChat" alt="" class="open">
    <img src="../assets/images/app_bg.png" alt="" class="open">
    <div class="app-list">
      <!-- <div :class="['app-item',val.class]" :key="key" v-for="(val,key) in appList" @click="toApp(key)">{{val.name}}</div> -->
      <img src="../assets/images/load_t.png" @click="toApp(0)">
      <span class="btn-open-app" @click="openApp">打开教师端</span>
    </div>
  </div>
</template>

<script>
  import Http from "../lib/Http";

  export default {
    data() {
      return {
        // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.0.apk'
        // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.1.apk'
        appList:[
          {name:'教师版下载',class:'app-teacher'}
        ],
        appUrl:[
          {
            iosUrl:'https://itunes.apple.com/cn/app/慧学宝/id1427169032?mt=8',
            androidUrl:'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.5.6.apk',
          }
        ],
        weChat:false,
      }
    },
    methods: {
      isPC() {
        const userAgentInfo = navigator.userAgent;
        const Agents = ["Android", "iPhone", "Windows Phone", "iPad", "iPod"];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      isWeChat(){
        let ua = navigator.userAgent.toLowerCase();
        if(ua.indexOf("micromessenger") != -1 ||  ua.indexOf("qq/") != -1) {
          this.weChat = true;
        } else{
          this.weChat = false;
        }
      },
      toApp(key){
        const ua = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(ua)) {
            window.location.href = this.appUrl[key].iosUrl;
        } else if (/android/.test(ua)) {
          // window.location.href = this.appUrl[key].androidUrl;
          let softwareId = key===1?7:5
          Http.Axios.get(`${Http.SIGN_NAME_API_ROOT()}cms/api/software/latest/${softwareId}`, {}).then(function (res) {
            // console.log(res)
            window.location.href = res.data.data.fileUrl
          }).catch(function (err) {

          });
        }
      },
      openApp(){
        let _this = this;
        // window.location.href = 'https://m.zsyte.zhixinhuixue.com';
        let iosUrl = 'zsyte://'
        let androidUrl = 'zxhx://teacher.app/openwith?openType=1'
        const ua = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(ua)) {
          window.location.href = iosUrl;
        } else if (/android/.test(ua)) {
          window.location.href = androidUrl;
        }
        setTimeout(() => {
          _this.toApp();
        }, 3000);
      }
    },
    mounted(){
      this.isWeChat();
      // window.location.reload();
    }
  }
</script>

<style scoped>
.app-download{
  position:relative;
  height: 100vh;
  background: #fcfffe;
  /* background:url(../assets/images/app_bg.png) no-repeat left center; */
  background-size: 100%;
}
.open{
  width: 100%;
}
.app-list{
  position: absolute;
  left:50%;
  bottom:6%;
  transform:translateX(-50%);
  -webkit-transform: translateX(-50%);
  font-size:16px;
  width: 56%;
}
.app-list img{
  margin-bottom:30px;
  width:100%;
}
.btn-open-app{
  display: inline-block;
  width: 100%;
  margin-bottom:30px;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  color: #EE6723;
  border:2px solid #EE6723;
  border-radius: 0.5rem;
  font-size: 0.4rem;
  box-sizing: border-box;
}
.app-item{
  margin-bottom:30px;
  line-height: 36px;
  text-align: center;
  border:2px solid #A0DA58;
  border-radius: 20px;
  background: #A0DA58;
  color: #fff;
  box-sizing: border-box;
}
/* .app-teacher{border: 2px solid #89693C;} */
.app-student{
  margin-bottom: 60px;
  border: 2px solid #89693C;
  color: #89693C;
  background: none;
}
</style>



// WEBPACK FOOTER //
// AppTeachDownload.vue?6b4808af